// extracted by mini-css-extract-plugin
export default {"modalContent":"FilePreviewModal_modalContent__W6UBY","maskBackground":"FilePreviewModal_maskBackground__C4r0a"};